import { render, staticRenderFns } from "./modal-update-name.vue?vue&type=template&id=ea6cc4e2&"
import script from "./modal-update-name.vue?vue&type=script&lang=js&"
export * from "./modal-update-name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports